import React, { type ComponentProps } from 'react';
import { FontAwesomeIcon } from '@rivallapp/volosports-components';

type ProgressBarIconProps = ComponentProps<typeof FontAwesomeIcon> & {
  className: React.HTMLAttributes<HTMLDivElement>['className'];
};

const ProgressBarIcon: React.FC<ProgressBarIconProps> = ({ className, size, ...props }) => {
  return (
    <div
      className={className}
      style={{
        height: size as string,
        width: size as string,
      }}
    >
      <FontAwesomeIcon padding={0.5} {...props} />
    </div>
  );
};

export default ProgressBarIcon;
